export enum MessageStatusEnum {
    SCHEDULED = 'SCHEDULED',
    CONFIRMED = 'CONFIRMED',
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    FAILED = 'FAILED'
}
